if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        // 🔵 Clear error when variant selected (specific product only)
        
        // 🎯 TARGET PRODUCT HANDLE (ONLY THIS PRODUCT WILL HAVE VALIDATION) code start for this task #125989 */
        
        this.targetHandle = 'the-4-day-mba-live-in-person-and-on-zoom-april-9-12-2026-austin-texas';

        // 🔵 CLEAR POPUP ERROR WHEN VARIANT SELECTED
        if (this.dataset.productHandle === this.targetHandle) {

          const formId = this.form.getAttribute('id');

          // Because radios are outside form (using form="id"),
          // we listen globally and match using form attribute
          document.addEventListener('change', (event) => {

            if (
              event.target.matches(`input[data-variant-radio][form="${formId}"]`)
            ) {
              // Clear error state when user selects variant
              this.error = false;
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
        }

        /* code end for this task #125989 */

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // CUSTOM POPUP FUNCTION code start for this task #125989
      
      showVariantPopup(message) {

        // Remove existing popup
        const existing = document.querySelector('.variant-error-popup');
        if (existing) existing.remove();

        document.body.classList.add('variant-popup-open');

        const popup = document.createElement('div');
        popup.className = 'variant-error-popup';
        popup.innerHTML = `
          <div class="variant-error-popup__box">
            <p>${message}</p>
            <button class="variant-error-popup__close">OK</button>
          </div>
        `;

        document.body.appendChild(popup);

        const closePopup = () => {
          popup.remove();
          document.body.classList.remove('variant-popup-open');
        };

        popup.addEventListener('click', (e) => {
          if (e.target === popup) closePopup(); // click outside box
        });

        popup.querySelector('.variant-error-popup__close')
          .addEventListener('click', closePopup);
      }

      /* code end for this task */

      onSubmitHandler(evt) {

        evt.preventDefault();

        // ✅ ADD THIS VALIDATION BLOCK

        // 🔴 REQUIRED VALIDATION FOR SPECIFIC PRODUCT
        if (this.dataset.productHandle === this.targetHandle) {

          const formId = this.form.getAttribute('id');

          const radios = document.querySelectorAll(
            `input[data-variant-radio][form="${formId}"]`
          );

          const anyChecked = [...radios].some(radio => radio.checked);

          // ❌ If no variant selected → show popup instead of inline error
          if (!anyChecked) {

            this.showVariantPopup(
              'Please select your method of attending (In-Person or Zoom) before adding to cart.'
            );

            return; // Stop submission
          }
        }
        // ✅ END VALIDATION BLOCK

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
